import React, {useState, useEffect, useRef} from "react";
import {Tooltip} from "@mui/material";
import OverlayShare from "./components/OverlayShare";
import RatingLink from "./RatingLink";

function GameComponent({data}) {
    // eslint-disable-next-line no-unused-vars
    const [level, setLevel] = useState(data.level || 1);
    // eslint-disable-next-line no-unused-vars
    const [info, setInfo] = useState(data.info || {clicks: 0});

    // eslint-disable-next-line no-unused-vars
    const [isUp, setIsUp] = useState(false);
    const [money, setMoney] = useState(data.money || 0);
    const [countRunned, setCountRunned] = useState(data.countRunned || 0);
    const [funitems, setFunitems] = useState(data.funitems);
    const [clicker, setClicker] = useState(data.clicker);
    const [upgrade, setUpgrade] = useState(data.upgrade);
    const [lastBuyed, setLastBuyed] = useState(data.clicker.image_id);
    const [isShare, setIsShare] = useState(false);
    const [isShareRate, setIsShareRate] = useState(data.isShareRate || false);
    // eslint-disable-next-line no-unused-vars
    const [bg, setBg] = useState("");
    const [intervalId, setIntervalId] = useState(null);
    const [animations, setAnimations] = useState([]);
    const [wait, setWait] = useState(false);

    const mainRef = useRef();
    const mainCookieRef = useRef();
    const mainCookieElement = mainCookieRef.current;

    useEffect(() => {
        setCountRunned(cc => cc + 1);
        if (mainCookieElement) {
            mainCookieElement.addEventListener("mouseup", animateOnUp);
        }
        return () => {
            if (mainCookieElement) {
                mainCookieElement.removeEventListener("mouseup", animateOnUp);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderBg = () => {
        let bgTmp = [];

        for (const [index, item] of upgrade.entries()) {
            if (item.count > 0 && index !== 0) {
                const bgUrl = `url(/img/shop${index}.png)`;
                if (index === 6 || index === 8) {
                    bgTmp.unshift(bgUrl);
                } else {
                    bgTmp.push(bgUrl);
                }
            }
        }

        setBg(bgTmp.join(", "));
        mainRef.current.style.backgroundImage = bgTmp;
    };

    useEffect(() => {
        renderBg();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [upgrade]);

    useEffect(() => {
        const mainCookieElement = mainCookieRef.current;
        if (mainCookieElement) {
            if (wait) {
                mainCookieElement.classList.add(`wait_${lastBuyed}`);
            } else {
                const classesToRemove = Array.from(mainCookieElement.classList).filter(
                    (cls) => cls.startsWith("wait_")
                );
                classesToRemove.forEach((cls) => {
                    mainCookieElement.classList.remove(cls);
                });
            }
        }
    }, [wait, lastBuyed]);


    useEffect(() => {
        localStorage.setItem('dataLilRooster', JSON.stringify({
            money: money,
            level: level,
            clicker: clicker,
            countRunned: countRunned,
            funitems: funitems,
            info: info,
            upgrade: upgrade,
            isShareRate: isShareRate
        }))
    }, [level, clicker, countRunned, funitems, info, money, upgrade, isShareRate]);

    const buyFun = (element) => {
        if (
            !element ||
            element.isPurchaced === true ||
            element.index - clicker.index !== 1
        ) {
            return false;
        }
        if (money - element.price >= 0) {
            play();
            setMoney((money) => money - element.price);
            element.isPurchaced = true;
            setLevel(element.level);
            setClicker(element);

            setClicker((prevState) => ({
                ...prevState,
                image_id: prevState.index,
            }));

            setFunitems((items) => {
                const newItems = items.map((item) => {
                    if (item.id === element.id) {
                        const newItem = {...item};
                        newItem.isPurchaced = true;
                        return newItem;
                    }
                    return item;
                });
                return newItems;
            });

            if (!wait) {
                mainCookieRef.current.style.backgroundImage = `url('/img/rooster${element.index}_action_1.png')`;

                handleClickLilRooster();
            } else {
            }
        }
    };

    useEffect(() => {
        setLastBuyed(clicker.image_id);
        if (intervalId) {
            clearInterval(intervalId);
        }
        timeOutWait();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clicker]);

    const abbreviateNumber = (num, withAbbr = false, decimals = 2) => {
        let fixed = decimals;

        if (num === null) {
            return null;
        }
        if (num === 0) {
            return "0";
        }
        fixed = !fixed || fixed < 0 ? 0 : fixed;
        let b = num.toPrecision(2).split("e"),
            k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
            c =
                k < 1
                    ? num.toFixed(0 + fixed)
                    : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
            d = c < 0 ? c : Math.abs(c),
            e = d + ["", "K", "M", "B", "T"][k];
        return e;
    };

    const getHint = (item) => {
        const m = item.rate * item.money * (item.count + 1);
        if (item.count === 0 && money < item.price) {
            return (
                <div className={"tooltip hide"}>
                    <div dangerouslySetInnerHTML={{__html: item.description}}/>
                    <br/>
                    Buy {item.name} for ${abbreviateNumber(item.price, true, 2)}.
                    <br/>
                    New level will raise cashflow to: ${abbreviateNumber(m)}
                </div>
            );
        }
        return (
            <div className={"tooltip"}>
                <div dangerouslySetInnerHTML={{__html: item.description}}/>
                <br/>
                Buy {item.name} for ${abbreviateNumber(item.price, true, 2)}.
                <br/>
                New level will raise cashflow to: ${abbreviateNumber(m)}
            </div>
        );
    };
    const getHintFunItems = (item) => {
        if (money < item.price) {
            return (
                <div className="tooltip hide">
                    <>
                        <div dangerouslySetInnerHTML={{__html: item.description}}/>
                        <br/> Buy {item.name} for ${abbreviateNumber(item.price, true, 2)}
                    </>
                </div>
            );
        } else {
            return (
                <div className="tooltip ">
                    <>
                        <div dangerouslySetInnerHTML={{__html: item.description}}/>
                        <br/> Buy {item.name} for ${abbreviateNumber(item.price, true, 2)}
                    </>
                </div>
            );
        }
    };
    const animateOnUp = () => {
        mainCookieRef.current.style.backgroundImage = `url(/games/lilrooster/img/rooster${clicker.index}_action_1.png)`;
    };
    const animateOnDown = () => {
        mainCookieRef.current.style.backgroundImage = `url(/games/lilrooster/img/rooster${clicker.index}_action_2.png)`;
        // eslint-disable-next-line no-unused-vars
        const timeoutId = setTimeout(() => {
            mainCookieRef.current.style.backgroundImage = `url(/games/lilrooster/img/rooster${clicker.index}_action_1.png)`;
        }, 300);
    };

    const getRandomInt = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    const timeOutWait = () => {
        if (intervalId) {
            clearInterval(intervalId);
        }
        const newIntervalId = setInterval(() => {
            statusWait();
        }, 2000);

        setIntervalId(newIntervalId);
    };

    const statusWait = () => {
        setWait(true);
    };

    const handleClickLilRooster = (e) => {
        setWait(false);
        animateOnDown();
        let sumClick =
            upgrade[0].money *
            (upgrade[0].count + 1) *
            clicker.rate *
            upgrade[0].rate;
        nums(e, sumClick);
        setMoney((money) => money + sumClick);
        setInfo((info) => info.click + 1);
        setIsUp(true);
        timeOutWait();

        const mainCookieElement = mainCookieRef.current;
        if (mainCookieElement) {
            const classesToRemove = Array.from(mainCookieElement.classList).filter(
                (cls) => cls.startsWith("wait_")
            );

            classesToRemove.forEach((cls) => {
                mainCookieElement.classList.remove(cls);
            });
        }
    };
    const play = () => {
        let audio = new Audio("/transfer_complete.mp3");
        audio.play();
    };
    const buy = (element) => {
        if (money - element.price >= 0) {
            play();
            setMoney((money) => money - element.price);

            setUpgrade((items) => {
                const newItems = items.map((item) => {
                    if (item.id === element.id) {
                        const newItem = {...item};
                        newItem.count++;
                        newItem.price =
                            Math.ceil(element.price * element.ratePrice * 10) / 10;
                        if (
                            element.autoClick &&
                            [5, 10, 15, 20, 25, 30, 35].includes(element.count)
                        ) {
                            newItem.money = element.money * 1.5;
                        }
                        if (
                            !element.autoClick &&
                            element.count % 5 === 0 &&
                            element.count <= 50
                        ) {
                            newItem.rate = (newItem.count / 5) * 3;
                        } else {
                            newItem.rate = element.rate;
                        }
                        return newItem;
                    }
                    return item;
                });

                return newItems;
            });
        }
        //save()
    };

    const closeOverlay = () => {
        setIsShare(true);
        setIsShareRate(true);
    };

    const animateAddMoney = (x, y, sum) => {
        const newAnimation = {x, y, sum, key: Math.random()};

        setAnimations((currentAnimations) => [...currentAnimations, newAnimation]);

        setTimeout(() => {
            setAnimations((currentAnimations) =>
                currentAnimations.filter(
                    (animation) => animation.key !== newAnimation.key
                )
            );
        }, 500);
    };

    const nums = (e, sum) => {
        let mouseX = 180 + getRandomInt(-20, 20),
            mouseY = 250 + getRandomInt(0, 1);

        try {
            animateAddMoney(mouseX, mouseY, abbreviateNumber(sum));
        } catch (ex) {
        }
    };

    return (
        <div className={"wrapper"}>
            <div className={"work"}>
                <div className={"game content"}>
                    <div className={`left noselect funitems`}>
                        {funitems.map((item, index) => {
                            const tooltip = getHintFunItems(item);
                            if (item.isPurchaced === true) {
                                return (
                                    <Tooltip
                                        key={item.id}
                                        title={tooltip}
                                        placement="right"
                                        disableInteractive
                                        arrow
                                    >
                                        <div
                                            className={`update bayed fun_${item.index} `}
                                            id={item.id}
                                            data-stop={item.index}
                                        ></div>
                                    </Tooltip>
                                );
                            } else {
                                return (
                                    <Tooltip
                                        title={money >= item.price && tooltip}
                                        placement="right"
                                        key={item.id}
                                        arrow={true}
                                        disableInteractive
                                    >
                                        <div
                                            className={`update fun fun_${item.index} ${
                                                item.index - lastBuyed === 1 && money >= item.price
                                                    ? "visible"
                                                    : "opacityNone"
                                            } ${money >= item.price && "visible"}`}
                                            id={item.id}
                                            onClick={() => buyFun(item)}
                                            data-index={index}
                                            style={{
                                                opacity: money >= item.price ? 1 : 0.5,
                                            }}
                                        >
                                            <div className="money">
                                                {" "}
                                                ${abbreviateNumber(item.price, true, 2)}
                                            </div>
                                        </div>
                                    </Tooltip>
                                );
                            }
                        })}
                    </div>
                    <div className={`main noselect `} ref={mainRef}>
                        <div className={"headerGame"}>
                            <div className={"profitstatus"}>
                                <span>${abbreviateNumber(money)}</span>
                            </div>
                            <Tooltip
                                title={"Give Lil Roo$ter 5 Stars"}
                                placement="bottom-end"
                                arrow
                                disableInteractive
                            >
                                <div className={"rating pulse"}>
                                    <span>  <RatingLink
                                        defaultValue={5}
                                        url="https://chrome.google.com/webstore/detail/lil-rooster-money-clicker/bkepnpnddicncpiffoefjlgjenfjpjib/reviews"
                                    /></span>
                                </div>
                            </Tooltip>
                        </div>
                        <div className={"imgWrap"}>
                            <div
                                className={"mainCookie"}
                                ref={mainCookieRef}
                                onClick={handleClickLilRooster}
                                style={{
                                    backgroundImage: `url(/img/rooster${lastBuyed}_wait_1.png)`,
                                }}
                            ></div>
                        </div>
                        {animations.map(({x, y, sum, key}) => (
                            <div
                                key={key}
                                style={{left: x, top: y}}
                                className="animationMoney temp noselect"
                            >
                                +{sum}
                            </div>
                        ))}
                    </div>
                    <div className={`shop noselect`}>
                        {upgrade.map((item, index) => {
                            const hint = getHint(item);
                            return (
                                <Tooltip
                                    title={money >= item.price && hint}
                                    placement="left"
                                    key={JSON.stringify(item)}
                                    arrow={true}
                                    disableInteractive
                                >
                                    <div
                                        id={item.id}
                                        data-index={index}
                                        data-badge={item.count}
                                        onClick={(e) => {
                                            buy(item);
                                        }}
                                        className={`update badge  ${
                                            item.count !== 0 && "shop_" + index
                                        }`}
                                        style={{
                                            opacity: money >= item.price ? 1 : 0.5,
                                        }}
                                    >
                                        <div className={"money"}>
                                            {abbreviateNumber(item.price, true, 1)}
                                        </div>
                                    </div>
                                </Tooltip>
                            );
                        })}
                    </div>
                </div>
            </div>
            {isShare === false && money > 120000 && (
                <OverlayShare
                    title={
                        <>
                            YOU’RE ON <span className="fire-text"> FIRE! </span>
                        </>
                    }
                    descriptionOne={"Love playing Lil Roo$ter clicker game?"}
                    descriptionTwo={
                        "We would be very grateful if you share it with your friends!"
                    }
                    text={"Share Lil Roo$ter"}
                    url={
                        "https://twitter.com/intent/tweet?text=https%3A//chromewebstore.google.com/detail/lil-rooster-money-clicker/bkepnpnddicncpiffoefjlgjenfjpjib"
                    }
                    closeOverlay={closeOverlay}
                />
            )}
            {isShareRate === false && (countRunned === 3 || countRunned === 7 || countRunned === 50 || countRunned === 75) && (
                <OverlayShare
                    title={"Give Lil Roo$ter 5 Stars"}
                    descriptionOne={"What is an art without popular renown? "}
                    descriptionTwo={
                        "Therefore, we would be very grateful if you could tell us a few words about Lil Rooster Money Clicker!"
                    }
                    text={"Leave feedback"}
                    url={
                        "https://chrome.google.com/webstore/detail/bkepnpnddicncpiffoefjlgjenfjpjib/reviews"
                    }
                    closeOverlay={closeOverlay}
                />
            )}
        </div>
    );
}

export default GameComponent;
